import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "مولد الاسماء - مولد اسماء الذكور والإناث - احصل على اسم لطفلك";
const DESCRIPTION =
  "استخدم مولد الأسماء لاكتشاف تشكيلة واسعة من الأسماء الفريدة والجميلة. سواء كنت تبحث عن أسماء عربية، غربية، إسلامية، شرقية، فاخرة، أو نادرة، يقدم لك هذا المولد خيارات متنوعة للعثور على الاسم المثالي لمولدك الجديد!";
const KEYWORDS =
  "مولد أسماء، أسماء عربية، أسماء غربية، أسماء إسلامية، أسماء شرقية، أسماء فاخرة، أسماء نادرة، توليد أسماء، مولد أسماء عربي، مولد أسماء فاخرة";
const OG_URL = "https://do-calculate.com/calculator/ar/random-name-generator";
const arabicIslamicNames = [
  {
    name: "محمد",
    meaning: "المحمود المحبوب، وهو اسم نبي الأمة صلى الله عليه وسلم",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أحمد",
    meaning: "الممدوح، وهو من اسماء النبي محمد صلى الله عليه وسلم",
    gender: "male",
    type: "islamic",
  },
  { name: "براء", meaning: "البريء من التهم", gender: "male", type: "islamic" },
  {
    name: "علي",
    meaning: "العالي، وهو اسم للشرف والرفعة",
    gender: "male",
    type: "islamic",
  },
  {
    name: "يوسف",
    meaning: "الذي يزداد في الجمال والحسن",
    gender: "male",
    type: "islamic",
  },
  {
    name: "عمر",
    meaning: "الحياة والعمر الطويل",
    gender: "male",
    type: "islamic",
  },
  {
    name: "طارق",
    meaning: "النجم اللامع، وهو اسم للشخص الذي يمهد الطريق للآخرين",
    gender: "male",
    type: "islamic",
  },
  { name: "رضوان", meaning: "الرضا والسرور", gender: "male", type: "islamic" },
  {
    name: "خالد",
    meaning: "الخالد، وهو الذي يبقى ولا يزول",
    gender: "male",
    type: "islamic",
  },
  {
    name: "زياد",
    meaning: "الزيادة والتزايد في الخير",
    gender: "male",
    type: "islamic",
  },
  {
    name: "عبدالله",
    meaning: "عبد الله، وهو الذي يعبد الله",
    gender: "male",
    type: "islamic",
  },
  { name: "سعيد", meaning: "السعيد والمبتهج", gender: "male", type: "islamic" },
  { name: "حسن", meaning: "الجمال والحسن", gender: "male", type: "islamic" },
  {
    name: "مصطفى",
    meaning: "المختار والمصطفى",
    gender: "male",
    type: "islamic",
  },
  {
    name: "عبدالرحمن",
    meaning: "عبد الرحمن، وهو العبد الذي لديه رحمة كبيرة",
    gender: "male",
    type: "islamic",
  },
  {
    name: "عبدالعزيز",
    meaning: "عبد العزيز، وهو العبد الذي لديه عزة وقوة",
    gender: "male",
    type: "islamic",
  },
  {
    name: "فاروق",
    meaning: "المميز بين الحق والباطل",
    gender: "male",
    type: "islamic",
  },
  {
    name: "نورالدين",
    meaning: "نور الدين، وهو النور الذي يضيء الدين",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أسامة",
    meaning: "الأسد الشجاع، وهو اسم للشجاعة والقوة",
    gender: "male",
    type: "islamic",
  },
  { name: "أيمن", meaning: "الحليم والرحيم", gender: "male", type: "islamic" },
  {
    name: "فهد",
    meaning: "الفهد، وهو اسم للشجاعة والقوة",
    gender: "male",
    type: "islamic",
  },
  { name: "سلمان", meaning: "السلام والأمان", gender: "male", type: "islamic" },
  {
    name: "مؤمن",
    meaning: "المؤمن، وهو الذي يؤمن بالله",
    gender: "male",
    type: "islamic",
  },
  { name: "رياض", meaning: "الجنة والراحة", gender: "male", type: "islamic" },
  { name: "صالح", meaning: "الصالح والنافع", gender: "male", type: "islamic" },
  {
    name: "ياسر",
    meaning: "الذي يسهل وييسر الأمور",
    gender: "male",
    type: "islamic",
  },
  { name: "معاذ", meaning: "المعيذ والحامي", gender: "male", type: "islamic" },
  { name: "أمجد", meaning: "المجد والفخر", gender: "male", type: "islamic" },
  { name: "أنس", meaning: "الصاحب والرفيق", gender: "male", type: "islamic" },
  { name: "جلال", meaning: "الجلال والعظمة", gender: "male", type: "islamic" },
  {
    name: "محسن",
    meaning: "المحسن والمحسن إليه",
    gender: "male",
    type: "islamic",
  },
  { name: "عادل", meaning: "العادل والمنصف", gender: "male", type: "islamic" },
  { name: "ناصر", meaning: "الناصر والمنصور", gender: "male", type: "islamic" },
  {
    name: "مجاهد",
    meaning: "المجاهد في سبيل الله",
    gender: "male",
    type: "islamic",
  },
  {
    name: "حمزة",
    meaning: "الأسد الشجاع، وهو اسم للشجاعة والقوة",
    gender: "male",
    type: "islamic",
  },
  {
    name: "إلياس",
    meaning: "نسبة إلى إلياس عليه السلام، واسمه يعني إلهي وربي",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أيوب",
    meaning: "نسبة إلى أيوب عليه السلام، واسمه يعني شديد الصبر على البلاء",
    gender: "male",
    type: "islamic",
  },
  {
    name: "إدريس",
    meaning: "نسبة إلى إدريس عليه السلام، حيث إن اسمه يدل على كثرة الدراسة",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أصهب",
    meaning: "اسم أطلقه القرآن الكريم على الأسد",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أصيل",
    meaning:
      "وهو من الأسماء التي تدل على الأصل، ولكن قصد به القرآن الكريم غروب الشمس",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أمان",
    meaning: "من الأسماء التي تدل على الطمأنينة والهدوء",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أمين",
    meaning:
      "هو الشخص الذي يتمتع بصفة الأمانة، وهو الشخص الذي يصون الأمانات بشكل عام",
    gender: "male",
    type: "islamic",
  },
  {
    name: "رابح",
    meaning: "هو الشخص الذي يقدر على تحقيق الغنائم والمكاسب",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أمجد",
    meaning: "من الأسماء التي تدل على الوصول على المكانة المميزة",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أنس",
    meaning:
      "من الأسماء التي يتم إطلاقها على الأشخاص الذين يشعرون بالألفة والطمأنينة",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أشجع",
    meaning: "من الأسماء المشتقة من الشجاعة، وهو الشخص الشجاع جبار البأس",
    gender: "male",
    type: "islamic",
  },
  {
    name: "أصمعي",
    meaning:
      "اسم له معنيان الأول هو الشخص صغير الأذنين، وهو من الأسماء التي تدل على السيف الصغير",
    gender: "male",
    type: "islamic",
  },
  {
    name: "ثابت",
    meaning: "اسم يدل على ثبات الشخص على موقف الحق",
    gender: "male",
    type: "islamic",
  },
  {
    name: "ثمود",
    meaning: "اسم يطلق على الشخص الكريم الذي نفذ ماله من شدة كرمه",
    gender: "male",
    type: "islamic",
  },
  {
    name: "عائشة",
    meaning: "مأخوذ من الفعل عاش ومعناه الحياة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "فاطمة",
    meaning: "مشتق من الفعل فطم ومعناه انقطع",
    gender: "female",
    type: "islamic",
  },
  {
    name: "أم كلثوم",
    meaning: "المرأة ذات الوجه الممتلئ",
    gender: "female",
    type: "islamic",
  },
  {
    name: "عاتكة",
    meaning: "الكريمة والجميلة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "عفيفة",
    meaning: "المرأة الطاهرة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "زينب",
    meaning: "شجر جميل الشكل والرائحة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "سودة",
    meaning: "الأرض التي يطرح بها النخيل",
    gender: "female",
    type: "islamic",
  },
  { name: "رحمة", meaning: "الرقة والرأفة", gender: "female", type: "islamic" },
  { name: "حنان", meaning: "الشفقة والرقة", gender: "female", type: "islamic" },
  {
    name: "إيمان",
    meaning:
      "التصديق بالله تعالى وملائكته وكتبه ورسله واليوم الآخر والقدر خيره وشره",
    gender: "female",
    type: "islamic",
  },
  {
    name: "نور",
    meaning: "الضياء والهداية",
    gender: "female",
    type: "islamic",
  },
  { name: "حكمة", meaning: "العلم والفهم", gender: "female", type: "islamic" },
  {
    name: "زينب",
    meaning: "الزهرة الجميلة",
    gender: "female",
    type: "islamic",
  },
  { name: "مريم", meaning: "مريم العذراء", gender: "female", type: "islamic" },
  {
    name: "سارة",
    meaning: "السهلة المطمئنة",
    gender: "female",
    type: "islamic",
  },
  { name: "هاجر", meaning: "الهاربة", gender: "female", type: "islamic" },
  { name: "آسيا", meaning: "ابنة مزاحم", gender: "female", type: "islamic" },
  {
    name: "خديجة",
    meaning: "التي تُخْدَجُ في عقلها وفضلها",
    gender: "female",
    type: "islamic",
  },
  {
    name: "ريحانة",
    meaning: "الزهرة الجميلة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "ريمان",
    meaning: "النخلة الصغيرة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "حوراء",
    meaning: "المرأة الجميلة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "جنات",
    meaning: "جمع جنة، وهي الحدائق ذات الأشجار المثمرة والماء العذب",
    gender: "female",
    type: "islamic",
  },
  {
    name: "حور",
    meaning: "جمع حورية، وهي من الحور العين في الجنة",
    gender: "female",
    type: "islamic",
  },
  { name: "سندس", meaning: "الحرير الناعم", gender: "female", type: "islamic" },
  {
    name: "نعيم",
    meaning: "السعادة والراحة",
    gender: "female",
    type: "islamic",
  },
  { name: "مسك", meaning: "المسك العطري", gender: "female", type: "islamic" },
  {
    name: "إيمان",
    meaning: "اسم يدل على الإيمان بالله",
    gender: "female",
    type: "islamic",
  },
  {
    name: "محبة",
    meaning: "اسم يدل على المحبة والود",
    gender: "female",
    type: "islamic",
  },
  {
    name: "سعادة",
    meaning: "اسم يدل على السعادة والفرح",
    gender: "female",
    type: "islamic",
  },
  {
    name: "أمل",
    meaning: "اسم يدل على الأمل والتفاؤل",
    gender: "female",
    type: "islamic",
  },
  {
    name: "فرح",
    meaning: "اسم يدل على الفرح والسرور",
    gender: "female",
    type: "islamic",
  },
  {
    name: "حياة",
    meaning: "اسم يدل على الحياة والوجود",
    gender: "female",
    type: "islamic",
  },
  {
    name: "غادة",
    meaning: "اسم يدل على الفتاة الجميلة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "زهرة",
    meaning: "اسم يدل على الزهرة الجميلة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "إيمان",
    meaning: "اسم يدل على التصديق بالله",
    gender: "female",
    type: "islamic",
  },
  {
    name: "إسلام",
    meaning: "اسم يدل على الاستسلام لله",
    gender: "female",
    type: "islamic",
  },
  {
    name: "تقوى",
    meaning: "اسم يدل على الخوف من الله والعمل بطاعته",
    gender: "female",
    type: "islamic",
  },
  {
    name: "رحمة",
    meaning: "اسم يدل على الرقة والرأفة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "حنان",
    meaning: "اسم يدل على الشفقة والرقة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "سندس",
    meaning: "ثياب أهل الجنة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "جنة",
    meaning: "جزاء المؤمنين الأشجار ثواب المؤمنين",
    gender: "female",
    type: "islamic",
  },
  {
    name: "سلسبيل",
    meaning: "الماء العذب السهل، وهو اسم يطلق على عين في الجنة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "جنات",
    meaning:
      "جمع الجنة التي يثاب بها المسلم على أعماله في الآخرة بمنازل متعددة أعلاها الفردوس",
    gender: "female",
    type: "islamic",
  },
  {
    name: "حور",
    meaning: "نصيب المؤمنين في الجنة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "قطوف",
    meaning: "كل ما يتم قطفه من ثمار الجنة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "فردوس",
    meaning: "أعلى منزلة في الجنة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "كوثر",
    meaning: "اسم من أنهار الجنة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "نمارق",
    meaning: "الوسائد التي يتكئ عليها أهل الجنة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "استبرق",
    meaning: "ثياب أهل الجنة",
    gender: "female",
    type: "islamic",
  },
  {
    name: "إيهاب",
    meaning: "إعداد شيء أو هدية وتقديمها إلى شخص، يدل على الكرم",
    gender: "male",
    type: "eastern",
  },
  {
    name: "وجدي",
    meaning: "يعني المحبة والفرح والحب الشديد، اسم عربي قديم",
    gender: "male",
    type: "eastern",
  },
  {
    name: "كيان",
    meaning: "يعني القيمة العالية والوجود والمكانة المرموقة، اسم عربي جديد",
    gender: "male",
    type: "eastern",
  },
  {
    name: "فهد",
    meaning: "يعني الفهد، وهو رمز للقوة والشجاعة في الثقافة العربية",
    gender: "male",
    type: "eastern",
  },
  {
    name: "رائد",
    meaning: "يعني الرائد أو القائد، ويشير إلى الشخص الذي يقود ويتقدم",
    gender: "male",
    type: "eastern",
  },
  {
    name: "جاد",
    meaning: "يعني الجود والكرم، وهو اسم يشير إلى الشخص السخي والكريم",
    gender: "male",
    type: "eastern",
  },
  {
    name: "صالح",
    meaning: "يعني الصالح أو النافع، وهو اسم يدل على الخير والنجاح",
    gender: "male",
    type: "eastern",
  },
  {
    name: "مجد",
    meaning:
      "يعني المجد والعظمة، وهو اسم يشير إلى الشخص الذي يحقق إنجازات عظيمة",
    gender: "male",
    type: "eastern",
  },
  {
    name: "هاني",
    meaning: "يعني السعيد والمبتهج، وهو اسم يدل على الفرح والراحة",
    gender: "male",
    type: "eastern",
  },
  {
    name: "نديم",
    meaning:
      "يعني الصديق المخلص والرفيق، وهو اسم يشير إلى الشخص الذي يكون صديقًا حميمًا",
    gender: "male",
    type: "eastern",
  },
  {
    name: "معاذ",
    meaning: "يعني الحاضن والمحمي، ويشير إلى الشخص الذي يقوم بحماية الآخرين",
    gender: "male",
    type: "eastern",
  },
  {
    name: "عادل",
    meaning:
      "يعني العدل والانصاف، ويشير إلى الشخص الذي يسعى للعدل في كل الأمور",
    gender: "male",
    type: "eastern",
  },
  {
    name: "سامر",
    meaning: "يعني الليل والسهر، ويشير إلى الشخص الذي يحب النشاط في الليل",
    gender: "male",
    type: "eastern",
  },
  {
    name: "باسل",
    meaning: "يعني الشجاع والجسور، ويمثل الشخص ذو الروح القوية",
    gender: "male",
    type: "eastern",
  },
  {
    name: "مجتبى",
    meaning:
      "يعني المختار والمفضل، ويشير إلى الشخص الذي يحظى بالتقدير والاختيار",
    gender: "male",
    type: "eastern",
  },
  {
    name: "رياض",
    meaning: "يعني الحدائق والمروج، ويمثل الجمال والطبيعة",
    gender: "male",
    type: "eastern",
  },
  {
    name: "عمار",
    meaning:
      "يعني البناء والتطوير، ويشير إلى الشخص الذي يسعى لتحسين الأمور من حوله",
    gender: "male",
    type: "eastern",
  },
  {
    name: "طارق",
    meaning: "يعني الناجح والمنجح، ويشير إلى الشخص الذي يحقق النجاح في مجاله",
    gender: "male",
    type: "eastern",
  },
  {
    name: "عليان",
    meaning: "يعني العالي والفاخر، ويمثل الشخص ذو القيمة العالية",
    gender: "male",
    type: "eastern",
  },
  {
    name: "ريان",
    meaning: "يعني الغصن الأخضر أو الشخص الذي شرب حتى ارتوى",
    gender: "male",
    type: "eastern",
  },
  {
    name: "أصيل",
    meaning: "يُعبِّر عن صاحب الأصالة والجود",
    gender: "male",
    type: "eastern",
  },
  {
    name: "ضرغام",
    meaning: "يرتبط بأحد أسماء الأسد ويعني القوة والشجاعة والإقدام",
    gender: "male",
    type: "eastern",
  },
  {
    name: "مُهاب",
    meaning: "يُعبِّر عن الشخص صاحب الهيبة والوقار والاحترام",
    gender: "male",
    type: "eastern",
  },
  {
    name: "كنان",
    meaning: "يعني الستار، ويُرمز به إلى السرية والحماية",
    gender: "male",
    type: "eastern",
  },
  {
    name: "سنان",
    meaning: "يشير إلى الشخص القوي والسريع والذي يتمتع بالحيوية",
    gender: "male",
    type: "eastern",
  },
  {
    name: "همام",
    meaning: "يُعبِّر عن الشخص الشجاع والمقدام",
    gender: "male",
    type: "eastern",
  },
  {
    name: "نيشان",
    meaning: "اسم بأصل كردي يعني الإشارة",
    gender: "male",
    type: "eastern",
  },
  {
    name: "أجود",
    meaning: "يشير إلى الشخص الأفضل بين الناس",
    gender: "male",
    type: "eastern",
  },
  { name: "أبيل", meaning: "الشخص الجميل.", gender: "male", type: "eastern" },
  { name: "نوفل", meaning: "الخص المعطاء.", gender: "male", type: "eastern" },
  {
    name: "ساهر",
    meaning: "المتأخر في النوم.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "ملهم",
    meaning: "مشتق من الإلهام.",
    gender: "male",
    type: "eastern",
  },
  { name: "لؤي", meaning: "الثور الوحشي.", gender: "male", type: "eastern" },
  {
    name: "معاذ",
    meaning: "الشخص المُحصن بالله.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "نيروز",
    meaning: "مشتق من عيد الربيع.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "رائف",
    meaning: "مشتق من الرأفة والرحمة.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "تائب",
    meaning: "مشتق من التوبة وهو الطائع.",
    gender: "male",
    type: "eastern",
  },
  { name: "أسمر", meaning: "اللون الأسمر.", gender: "male", type: "eastern" },
  {
    name: "باهي",
    meaning: "شديد الجمال والحسن.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "تيام",
    meaning: "ذهاب العقل من شدة الهوى.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "براء",
    meaning: "الشخص السليم من الأسقام.",
    gender: "male",
    type: "eastern",
  },
  { name: "بشر", meaning: "طليق الوجه.", gender: "male", type: "eastern" },
  { name: "داغر", meaning: "المهاجم بقوة.", gender: "male", type: "eastern" },
  {
    name: "يامن",
    meaning: "المبارك والميمون.",
    gender: "male",
    type: "eastern",
  },
  { name: "دالي", meaning: "العنب الأسود.", gender: "male", type: "eastern" },
  { name: "ذو الفقار", meaning: "اسم سيف.", gender: "male", type: "eastern" },
  { name: "ثائر", meaning: "مُعلن الثورة.", gender: "male", type: "eastern" },
  { name: "آسر", meaning: "القوي الشديد.", gender: "male", type: "eastern" },
  {
    name: "مازن",
    meaning: "مشتق من المزن أي السحاب.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "أمجد",
    meaning: "صاحب المجد العريق.",
    gender: "male",
    type: "eastern",
  },
  { name: "أرغد", meaning: "الأرض الخصبة.", gender: "male", type: "eastern" },
  {
    name: "بلال",
    meaning: "الماء الذي يبلل الحلق.",
    gender: "male",
    type: "eastern",
  },
  { name: "بيبرس", meaning: "القوي المقاتل.", gender: "male", type: "eastern" },
  { name: "باسل", meaning: "الشجاع.", gender: "male", type: "eastern" },
  { name: "باهر", meaning: "محقق النجاح.", gender: "male", type: "eastern" },
  {
    name: "باهي",
    meaning: "مشتق من البهاء والحسن.",
    gender: "male",
    type: "eastern",
  },
  { name: "تيم", meaning: "العبد.", gender: "male", type: "eastern" },
  {
    name: "ثامر",
    meaning: "المثمر أو المنتج.",
    gender: "male",
    type: "eastern",
  },
  { name: "جاسر", meaning: "الجريء.", gender: "male", type: "eastern" },
  {
    name: "حاتم",
    meaning: "القاضي أو الحاكم.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "حمزة",
    meaning: "مشتق من الشدة والصلابة.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "حليم",
    meaning: "مشتق من صفة الحلم أو الصبر.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "باسم",
    meaning: "مشتق من الابتسامة والبشاشة.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "فهد",
    meaning: "اسم حيوان مفترس معروف بالقوة.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "زياد",
    meaning: "مشتق من الزيادة والكثرة.",
    gender: "male",
    type: "eastern",
  },
  { name: "غسان", meaning: "ريعان الشباب.", gender: "male", type: "eastern" },
  {
    name: "خاطر",
    meaning: "ما يخطر على البال.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "داني",
    meaning: "الشخص القريب في المكان.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "رافل",
    meaning: "قليل الغرور والتكبر.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "زهير",
    meaning: "مشتق من الزهور المتفتحة.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "كريم",
    meaning: "اسم يطلق على الشخص المعطاء.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "تامر",
    meaning: "اسم يشار به إلى كثرة الرزق.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "سُهَيْل",
    meaning: "اسم نجم في السماء.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "يحيى",
    meaning: "اسم نبي من أنبياء الله.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "نَوْفَل",
    meaning: "اسم يطلق على الشخص كثير العطاء.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "زياد",
    meaning: "اسم يطلق على النمو والعطاء.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "راجي",
    meaning: "اسم يطلق على الشخص الذي يرجو الشيء.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "ساهر",
    meaning: "اسم يطلق على من يتأخر في النوم.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "خَطَّاب",
    meaning: "اسم يطلق على كثير الخِطاب.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "رامز",
    meaning: "اسم يطلق على إيماءة أو إشارة.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "شادي",
    meaning: "اسم يطلق على طالب العلم والأدب.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "مازن",
    meaning: "اسم يطلق على من يتمزن على قومه.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "بشار",
    meaning: "اسم يطلق على من يجلب لغيره البشرى.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "باهر",
    meaning: "اسم يطلق على صاحب الوجه المنير.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "مُلهم",
    meaning: "اسم يطلق على الشخص الذي يوجه الآخرين لفعل الخير.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "يزيد",
    meaning: "اسم يطلق على الزيادة والنماء.",
    gender: "male",
    type: "eastern",
  },
  {
    name: "ريناد",
    meaning: "الرائحة الذكية العطرة، أيضاً هو اسم البخور المخصص للكعبة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ميار",
    meaning: "من تجلب الحظ أو الخير",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ليان",
    meaning: "يأتي من الليونة والمرونة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "زينا",
    meaning: "تعني الزينة والجمال",
    gender: "female",
    type: "eastern",
  },
  {
    name: "فاطمة",
    meaning: "اسم عربي يرتبط بالفتاة المتميزة والمشرقة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ربا",
    meaning: "تعني النمو والازدهار",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ملاك",
    meaning: "تعني المخلوق السماوي الطيب والجميل",
    gender: "female",
    type: "eastern",
  },
  {
    name: "رهام",
    meaning: "تعني النعومة والرقة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "وئام",
    meaning: "تعني الانسجام والتوازن",
    gender: "female",
    type: "eastern",
  },
  {
    name: "صفاء",
    meaning: "تعني النقاء والصفو",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ميساء",
    meaning: "تعني الليلة الممطرة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "إيمان",
    meaning: "تعني الإيمان والاستقامة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "سمية",
    meaning: "تعني السماوية والرفيعة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "نورا",
    meaning: "تعني النور والإشراق",
    gender: "female",
    type: "eastern",
  },
  {
    name: "لمى",
    meaning: "تعني النظرة الرقيقة والجميلة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "جواهر",
    meaning: "تعني الجواهر والدرر",
    gender: "female",
    type: "eastern",
  },
  {
    name: "إيناس",
    meaning: "تعني الراحة والطمأنينة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "نادية",
    meaning: "تعني النادرة والفريدة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "لبنى",
    meaning: "تعني اللبن الأبيض النقي",
    gender: "female",
    type: "eastern",
  },
  {
    name: "هالة",
    meaning: "تعني النور الذي يحيط بالقمر",
    gender: "female",
    type: "eastern",
  },
  {
    name: "سارة",
    meaning: "تعني السهلة المطمئنة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "هند",
    meaning: "تعني الهدية والجود",
    gender: "female",
    type: "eastern",
  },
  {
    name: "بتول",
    meaning: "تعني النقية والزكية",
    gender: "female",
    type: "eastern",
  },
  {
    name: "رغد",
    meaning: "تعني الراحة والاستمتاع",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ميادة",
    meaning: "تعني الفتاة السعيدة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "إلهام",
    meaning: "تعني الإلهام والإلهاز",
    gender: "female",
    type: "eastern",
  },
  {
    name: "رنا",
    meaning: "تعني الغناء والرقة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "وسن",
    meaning: "تعني الجمال والسناء",
    gender: "female",
    type: "eastern",
  },
  {
    name: "جميلة",
    meaning: "تعني الجمال والحسن",
    gender: "female",
    type: "eastern",
  },
  {
    name: "لطيفة",
    meaning: "تعني اللطف والرقة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "هيا",
    meaning: "تعني الحية والحيوية",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ريهام",
    meaning: "تعني النعومة والهدوء",
    gender: "female",
    type: "eastern",
  },
  {
    name: "فاتن",
    meaning: "تعني الفاتنة والجذابة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "تولاي",
    meaning: "ضوء القمر الخفيف",
    gender: "female",
    type: "eastern",
  },
  {
    name: "توانا",
    meaning: "أول قطرة مطر من السماء",
    gender: "female",
    type: "eastern",
  },
  {
    name: "أرلا",
    meaning: "اسم أجنبي معناه النسر",
    gender: "female",
    type: "eastern",
  },
  {
    name: "بارين",
    meaning: "اسم هندي بمعنى الملاك أو الجنية",
    gender: "female",
    type: "eastern",
  },
  {
    name: "جينا",
    meaning: "الفتاة النبيلة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ريام",
    meaning: "الفتاة المحبة أو العطوفة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "غلا",
    meaning: "مشتق من الغلو بمعنى ارتفاع القيمة",
    gender: "female",
    type: "eastern",
  },
  { name: "هنوف", meaning: "المرأة الضحوك", gender: "female", type: "eastern" },
  {
    name: "يوليا",
    meaning: "اسم يوناني يمعنى الكلام اللطيف",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ميلاء",
    meaning: "الشجرة كثيرة الفروع",
    gender: "female",
    type: "eastern",
  },
  {
    name: "لمى",
    meaning: "السمرة في الشفاه",
    gender: "female",
    type: "eastern",
  },
  {
    name: "روبين",
    meaning: "اسم ألماني بمعنى صانعة الأمجاد",
    gender: "female",
    type: "eastern",
  },
  {
    name: "وانا",
    meaning: "اسم أجنبي بمعنى الهدية",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ليان",
    meaning: "مشتق من الليونة بمعنى اللين والسهولة",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ليساء",
    meaning: "الفتاة الحسناء في الشكل والخلق",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ميس",
    meaning: "التبختر والتمايل",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ديمة",
    meaning: "المطر مع السكون",
    gender: "female",
    type: "eastern",
  },
  { name: "رهف", meaning: "الرقة واللطافة", gender: "female", type: "eastern" },
  {
    name: "رُبى",
    meaning: "مشتق من الربوة وهو كل ما ارتفاع عن الأرض",
    gender: "female",
    type: "eastern",
  },
  {
    name: "سيليا",
    meaning: "الأرض الواسعة الخضراء",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ماسة",
    meaning: "الحجر الثمين البراق",
    gender: "female",
    type: "eastern",
  },
  { name: "سديم", meaning: "الضباب الناعم", gender: "female", type: "eastern" },
  {
    name: "آسيا",
    meaning: "اسم فتاة جميلة، وهو اسم إحدى قارات العالم القديم.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "أرجوان",
    meaning: "اسم فتاة جميلة، وهو اسم زهرة مميزة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "أسيل",
    meaning: "اسم فتاة جميلة، وهو اسم نهر في الجنة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "أفنان",
    meaning: "اسم فتاة جميلة، وهو اسم الأشجار المثمرة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "أحلام",
    meaning: "اسم فتاة جميلة، وهو اسم الأحلام الجميلة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "أثير",
    meaning: "اسم فتاة جميلة، وهو اسم الهواء المنتشر في الكون.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "أسماء",
    meaning: "اسم فتاة جميلة، وهو اسم الأسماء.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "أزهار",
    meaning: "اسم فتاة جميلة، وهو اسم الزهور الجميلة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "بدر",
    meaning: "اسم فتاة جميلة، وهو اسم القمر المكتمل.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "بيان",
    meaning: "اسم فتاة جميلة، وهو اسم الوضوح والظهور.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "تيا",
    meaning: "اسم فتاة جميلة، وهو اسم نهر في الجنة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "تسنيم",
    meaning: "اسم فتاة جميلة، وهو اسم نهر في الجنة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "توبا",
    meaning: "اسم فتاة جميلة، وهو اسم التوبة والإنابة إلى الله.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "جمان",
    meaning: "اسم فتاة جميلة، وهو اسم اللؤلؤ والمجوهرات.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "حور",
    meaning: "اسم فتاة جميلة، وهو اسم نساء الجنة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "دانية",
    meaning: "اسم فتاة جميلة، وهو اسم القرب والانخفاض.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "رغد",
    meaning: "اسم فتاة جميلة، وهو اسم العيش الرغيد.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "رنا",
    meaning: "اسم فتاة جميلة، وهو اسم النظر والتعلق.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "سارة",
    meaning:
      "اسم فتاة جميلة، وهو اسم السيدة سارة زوجة النبي إبراهيم عليه السلام.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "سدرة",
    meaning: "اسم فتاة جميلة، وهو اسم شجرة في الجنة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "سناء",
    meaning: "اسم فتاة جميلة، وهو اسم الرفعة والشرف.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "شذى",
    meaning: "اسم فتاة جميلة، وهو اسم الرائحة العطرة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ضحى",
    meaning: "اسم فتاة جميلة، وهو اسم وقت الظهيرة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "عبير",
    meaning: "اسم فتاة جميلة، وهو اسم الرائحة الجميلة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "عفاف",
    meaning: "اسم فتاة جميلة، وهو اسم الستر والعفة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "غدير",
    meaning: "اسم فتاة جميلة، وهو اسم النهر الصغير.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "غفران",
    meaning: "اسم فتاة جميلة، وهو اسم المغفرة والعفو.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "حلا",
    meaning: "اسم فتاة جميلة، وهو اسم الحلاوة والجمال.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "هديل",
    meaning: "اسم فتاة جميلة، وهو اسم صوت الحمام.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "ياسمين",
    meaning: "اسم فتاة جميلة، وهو اسم زهرة مميزة.",
    gender: "female",
    type: "eastern",
  },
  {
    name: "جايدن",
    meaning: "الفتى الصغير المتجذر",
    gender: "male",
    type: "western",
  },
  {
    name: "لياندر",
    meaning: "المغامر الذي يستكشف الأرض",
    gender: "male",
    type: "western",
  },
  {
    name: "نولان",
    meaning: "الأمير أو القائد الشجاع",
    gender: "male",
    type: "western",
  },
  {
    name: "كارتر",
    meaning: "الساعي أو الحارس",
    gender: "male",
    type: "western",
  },
  { name: "هايزل", meaning: "شجرة البندق", gender: "male", type: "western" },
  { name: "جاكسون", meaning: "ابن جاك", gender: "male", type: "western" },
  { name: "ليفي", meaning: "مرفوع أو مرتفع", gender: "male", type: "western" },
  { name: "ماكسويل", meaning: "بئر الكنز", gender: "male", type: "western" },
  { name: "نيثان", meaning: "الهبة من الله", gender: "male", type: "western" },
  { name: "أوسكار", meaning: "فارس الله", gender: "male", type: "western" },
  {
    name: "كونر",
    meaning: "الفاتح أو الباحث عن المغامرة",
    gender: "male",
    type: "western",
  },
  {
    name: "جايسون",
    meaning: "الشاب الذي يحمل حزامًا",
    gender: "male",
    type: "western",
  },
  {
    name: "براندون",
    meaning: "السيف الساطع أو اللهب",
    gender: "male",
    type: "western",
  },
  {
    name: "كريغ",
    meaning: "الصخرة أو الصخرة الصغيرة",
    gender: "male",
    type: "western",
  },
  { name: "ديريك", meaning: "القائد الشعبي", gender: "male", type: "western" },
  {
    name: "إيثان",
    meaning: "المتين أو القوي",
    gender: "male",
    type: "western",
  },
  { name: "فيليب", meaning: "صديق الخيول", gender: "male", type: "western" },
  { name: "غاريت", meaning: "الحارس الشجاع", gender: "male", type: "western" },
  { name: "هنري", meaning: "الحاكم المنزلي", gender: "male", type: "western" },
  { name: "أيفريت", meaning: "رفيع أو راقي", gender: "male", type: "western" },
  {
    name: "جاستن",
    meaning: "العادل أو الصادق",
    gender: "male",
    type: "western",
  },
  { name: "كيلان", meaning: "الرفيق الحميم", gender: "male", type: "western" },
  { name: "ليون", meaning: "الشجاع والقوي", gender: "male", type: "western" },
  {
    name: "مايكل",
    meaning: "منسوب إلى الملاك ميخائيل",
    gender: "male",
    type: "western",
  },
  { name: "نيكولاس", meaning: "الشخص الناجح", gender: "male", type: "western" },
  {
    name: "أوليفر",
    meaning: "صاحب الألفة والود",
    gender: "male",
    type: "western",
  },
  {
    name: "بيتر",
    meaning: "الصخرة أو الصخرة الكبيرة",
    gender: "male",
    type: "western",
  },
  { name: "كوين", meaning: "الزعيم الشاب", gender: "male", type: "western" },
  {
    name: "رايلان",
    meaning: "شاب الطريق المتلألئ",
    gender: "male",
    type: "western",
  },
  {
    name: "سامويل",
    meaning: "اسم الله قد سمع",
    gender: "male",
    type: "western",
  },
  {
    name: "نيللي",
    meaning: "اسم يوناني بمعنى شعاع النور",
    gender: "female",
    type: "western",
  },
  {
    name: "إلين",
    meaning: "الأنيقة جميلة المظهر",
    gender: "female",
    type: "western",
  },
  {
    name: "جوليا",
    meaning: "اسم أجنبي بمعنى الفتاة الصبية",
    gender: "female",
    type: "western",
  },
  { name: "إيما", meaning: "الكلام الكثير", gender: "female", type: "western" },
  {
    name: "أوليفيا",
    meaning: "شجرة الزيتون",
    gender: "female",
    type: "western",
  },
  { name: "صوفيا", meaning: "الحكمة", gender: "female", type: "western" },
  {
    name: "إيفانجلين",
    meaning: "البشارة الجميلة",
    gender: "female",
    type: "western",
  },
  {
    name: "كلير",
    meaning: "الواضحة والنقية",
    gender: "female",
    type: "western",
  },
  {
    name: "ماديلين",
    meaning: "امرأة من المدينة الحرة",
    gender: "female",
    type: "western",
  },
  {
    name: "روزاليند",
    meaning: "حديقة الورود",
    gender: "female",
    type: "western",
  },
  {
    name: "فيكتوريا",
    meaning: "الفائزة أو الناجحة",
    gender: "female",
    type: "western",
  },
  {
    name: "كاثرين",
    meaning: "النقية والبريئة",
    gender: "female",
    type: "western",
  },
  {
    name: "ليليان",
    meaning: "الجمال النبيل",
    gender: "female",
    type: "western",
  },
  {
    name: "جيسيكا",
    meaning: "الثروة أو اليقظة",
    gender: "female",
    type: "western",
  },
  { name: "هانا", meaning: "نعمة", gender: "female", type: "western" },
  {
    name: "إليزابيث",
    meaning: "النذيرة بالله",
    gender: "female",
    type: "western",
  },
  {
    name: "سارة",
    meaning: "السهلة المطمئنة",
    gender: "female",
    type: "western",
  },
  {
    name: "راشيل",
    meaning: "الأغنية الجميلة",
    gender: "female",
    type: "western",
  },
  {
    name: "ناتالي",
    meaning: "المولودة في عيد الميلاد",
    gender: "female",
    type: "western",
  },
  {
    name: "لورين",
    meaning: "منخرطة في الشجن",
    gender: "female",
    type: "western",
  },
  { name: "إيفلين", meaning: "الحياة", gender: "female", type: "western" },
  {
    name: "إيسابيل",
    meaning: "تعني الله حلفاء",
    gender: "female",
    type: "western",
  },
  { name: "جوليت", meaning: "الشابة", gender: "female", type: "western" },
  { name: "أليسون", meaning: "النبيلة", gender: "female", type: "western" },
  {
    name: "كارولين",
    meaning: "المرأة الجميلة",
    gender: "female",
    type: "western",
  },
  {
    name: "ميغان",
    meaning: "اللؤلؤة اللامعة",
    gender: "female",
    type: "western",
  },
  {
    name: "ديانا",
    meaning: "الإلهة القمرية",
    gender: "female",
    type: "western",
  },
  {
    name: "جاكلين",
    meaning: "التالية بعد الآخرين",
    gender: "female",
    type: "western",
  },
  {
    name: "بيثاني",
    meaning: "البيت الصغير",
    gender: "female",
    type: "western",
  },
  {
    name: "كيتلين",
    meaning: "الفتاة النقية",
    gender: "female",
    type: "western",
  },
  {
    name: "هيلاري",
    meaning: "المبشرة بالفرح",
    gender: "female",
    type: "western",
  },
  {
    name: "ميليسا",
    meaning: "النحلة العاملة",
    gender: "female",
    type: "western",
  },
  {
    name: "جينيفر",
    meaning: "المرأة الجندرية",
    gender: "female",
    type: "western",
  },
  {
    name: "كادي",
    meaning: "أحد أنواع الأشجار",
    gender: "female",
    type: "western",
  },
  {
    name: "آدم",
    meaning: "الإنسان الأول، الأرض",
    gender: "both",
    type: "western",
  },
  {
    name: "جوان",
    meaning: "النعمة من الله",
    gender: "both",
    type: "western",
  },
  {
    name: "لورا",
    meaning: "الغار، الغابة",
    gender: "both",
    type: "western",
  },
];
function NameGenerator() {
  const [gender, setGender] = useState("male");
  const [types, setTypes] = useState([]);
  const [generatedName, setGeneratedName] = useState("");
  const [generatedType, setGeneratedType] = useState("");
  const [nameNotFound, setNameNotFound] = useState(false);
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const handleTypeChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setTypes((prevTypes) => [...prevTypes, value]);
    } else {
      setTypes((prevTypes) => prevTypes.filter((type) => type !== value));
    }
  };
  const generateRandomName = () => {
    setGeneratedName("");
    setGeneratedType("");
    setNameNotFound(false);
    const filteredNames = getFilteredNames();
    if (filteredNames.length > 0) {
      const randomIndex = Math.floor(Math.random() * filteredNames.length);
      const { name, meaning, type } = filteredNames[randomIndex];
      setGeneratedName(`${name} : ${meaning}`);
      setGeneratedType(type);
    } else {
      setNameNotFound(true);
    }
  };
  const getFilteredNames = () => {
    return arabicIslamicNames.filter((name) => {
      return (
        ((gender === "male" && name.gender === "male") ||
          (gender === "female" && name.gender === "female") ||
          (gender === "both" &&
            (name.gender === "male" || name.gender === "female"))) &&
        types.includes(name.type)
      );
    });
  };
  const getName = () => {
    return generatedName && generatedName.includes(":")
      ? generatedName.split(":")[0]
      : "";
  };
  const getMeaning = () => {
    return generatedName && generatedName.includes(":")
      ? generatedName.split(":")[1].trim()
      : "";
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقدم هذه الاداة طريقة فعالة لايجاد اسماء بنات اسسلامية, واسماء
                  ذكور اسلامية, واسماء عربية نادرة للذكور والإناث , كما ايضا
                  تساعدك على ايجاد اسماء مشتركة بين الشرق والغرب
                </p>
                <p>
                  سواء كنت تبحث عن أسماء عربية تقليدية، أو أسماء غربية معاصرة،
                  أو حتى أسماء إسلامية ذات معانٍ دينية، يوفر مولد الأسماء مجموعة
                  واسعة تلبي احتياجات مختلفة. من خلال توفير خيارات تشمل الأسماء
                  الشرقية والفاخرة، يمكنك العثور بسهولة على الاسم المثالي الذي
                  يعبر عن هوية طفلك الجديد.
                </p>
                <p>
                  باستخدام مولد الأسماء، يمكنك بسهولة استكشاف الخيارات المتاحة
                  وتصفح قائمة واسعة من الأسماء. يقوم المولد بتقديم معلومات
                  إضافية حول معاني الأسماء وأصولها، مما يسهل عليك اتخاذ قرار
                  مستنير.
                </p>
                <p>
                  إن اختيار اسم لمولودك يعتبر خطوة مهمة ومميزة في رحلة الأبوة
                  والأمومة. يسعى العديد من الأهل إلى اختيار أسماء تعبر عن تراثهم
                  الثقافي وتلامس قلوبهم بشكل خاص. في هذا السياق، يأتي "مولد
                  الأسماء" ليقدم لك تجربة فريدة لاكتشاف أسماء تجمع بين الجمال
                  والفخامة.
                </p>
                <p>
                  في النهاية، يهدف مولد الأسماء إلى توفير تجربة ممتعة ومفيدة
                  للأهل الذين يبحثون عن اسم مميز ويتناغم مع مشاعرهم وقيمهم.
                  اكتشف عالم الأسماء مع مولدنا واحصل على اسم يروق لقلبك ويضفي
                  لمسة فريدة على حياة صغيرك القادم.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div
                  className="form-group d-flex align-items-center"
                  style={{ justifyContent: "center" }}
                >
                  <b>
                    <label className="form-label " style={{ fontSize: "19px" }}>
                      الجنس
                    </label>
                  </b>
                  <div
                    style={{
                      marginRight: "40px",
                    }}
                  >
                    <FormControlLabel
                      value="male"
                      control={
                        <Radio
                          color="success"
                          checked={gender === "male"}
                          onChange={handleGenderChange}
                        />
                      }
                      label={
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: {
                              md: "17px",
                            },
                          }}
                        >
                          ذكر
                        </Typography>
                      }
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="female"
                      control={
                        <Radio
                          color="success"
                          checked={gender === "female"}
                          onChange={handleGenderChange}
                        />
                      }
                      label={
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: {
                              md: "17px",
                            },
                          }}
                        >
                          أنثى
                        </Typography>
                      }
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="both"
                      control={
                        <Radio
                          color="success"
                          checked={gender === "both"}
                          onChange={handleGenderChange}
                        />
                      }
                      label={
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: {
                              md: "17px",
                            },
                          }}
                        >
                          للذكر و الأنثى
                        </Typography>
                      }
                      labelPlacement="start"
                    />
                  </div>
                </div>
                <Box
                  className="d-flex align-items-center"
                  sx={{
                    marginLeft: {
                      lg: "40px",
                      xs: "20px",
                    },
                    justifyContent: "center",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={types.includes("islamic")}
                        onChange={handleTypeChange}
                        id="islamic"
                        value="islamic"
                        color="success"
                      />
                    }
                    label={
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: {
                            md: "17px",
                          },
                        }}
                      >
                        عربي إسلامي
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={types.includes("eastern")}
                        onChange={handleTypeChange}
                        id="eastern"
                        value="eastern"
                        color="success"
                      />
                    }
                    label={
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: {
                            md: "17px",
                          },
                        }}
                      >
                        عربي شرقي
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={types.includes("western")}
                        onChange={handleTypeChange}
                        id="western"
                        value="western"
                        color="success"
                      />
                    }
                    label={
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: {
                            md: "17px",
                          },
                        }}
                      >
                        عربي غربي
                      </Typography>
                    }
                  />
                  <br />
                </Box>
                <div className="text-center mt-3">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={generateRandomName}
                    sx={{
                      fontSize: {
                        md: "17px",
                      },
                    }}
                  >
                    إنشاء الاسم
                  </Button>
                </div>
              </div>
              {generatedName && !nameNotFound && (
                <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                  <table className="rtl">
                    <thead>
                      <tr>
                        <th>الأسم</th>
                        <th>معنى الأسم</th>
                        <th>نوعه</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{getName()}</td>
                        <td>{getMeaning()}</td>
                        <td>
                          {generatedType === "islamic"
                            ? "عربي إسلامي"
                            : generatedType === "eastern"
                              ? "عربي شرقي"
                              : generatedType === "western"
                                ? "عربي غربي"
                                : ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default NameGenerator;
